import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { BLUE_COLOR, ERROR_COLOR, ORANGE_COLOR } from "../../utils/const";
// header = [name1,name2,...]
// body = [[a,b],[c,d]]
const BillCustomTable = ({ header, body, hcolspan, type }) => {
  const typeColers = () => {
    if (type === "آب") {
      return BLUE_COLOR;
    } else if (type === "برق") {
      return ERROR_COLOR;
    } else {
      return ORANGE_COLOR;
    }
  };
  const headingStyle = {
    // color: "#ffffff",
    background: typeColers(),
  };
  return (
    <>
      <TableContainer style={{ marginBottom: "10px" }}>
        <Table style={{ borderBottom: "1px solid #000" }}>
          <TableHead>
            <TableRow style={headingStyle}>
              {header.map((item) => (
                <TableCell
                  colspan={hcolspan}
                  style={{
                    textAlign: "center",
                    padding: "0",
                    border: "1px solid #000",
                  }}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {body.map((item, idx) => (
              <TableRow>
                {item.map((d, i) => (
                  <TableCell
                    style={{
                      border: "1px solid #000",
                      padding: " 0",
                      textAlign: "center",
                      minHeight: "20px",
                    }}
                  >
                    {d || d === 0 ? d : "__"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
export default BillCustomTable;
